import React from "react";
import { TextField, Autocomplete, Box } from "@mui/material";

const CustAutoComplete = ({
  label,
  options,
  optionLabelName,
  uniqueKey,
  styles,
  txtFieldStyle,
  CustomRenderOptionData,
  ...props
}) => {
  return (
    <>
      <Autocomplete
        // loading
        size={props.size || "small"}
        style={{ ...styles }}
        getOptionLabel={(reportsName) => `${reportsName[optionLabelName]}`}
        options={options}
        renderOption={(prop, reportsName) => (
          <Box component="li" {...prop} key={reportsName[uniqueKey]}>
            {reportsName[optionLabelName]}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            style={{
              borderRadius: "10px",
              background:
                (props?.disabled && "#f3efef") ||
                (props?.readOnly && "#f3efef"),
              ...txtFieldStyle,
            }}
            label={label}
          />
        )}
        {...props}
      />
    </>
  );
};

export default CustAutoComplete;
